export const Exit = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.08917 2.00745C7.5 2.52995 7.5 3.48578 7.5 5.39662V14.6033C7.5 16.5141 7.5 17.4699 8.08917 17.9925C8.67833 18.5149 9.57917 18.3583 11.3808 18.0441L13.3225 17.7058C15.3175 17.3575 16.315 17.1833 16.9075 16.4516C17.5 15.7191 17.5 14.6608 17.5 12.5433V7.45662C17.5 5.33995 17.5 4.28162 16.9083 3.54912C16.315 2.81745 15.3167 2.64328 13.3217 2.29578L11.3817 1.95662C9.58 1.64245 8.67917 1.48578 8.09 2.00828M10 8.47412C10.345 8.47412 10.625 8.76662 10.625 9.12745V10.8724C10.625 11.2333 10.345 11.5258 10 11.5258C9.655 11.5258 9.375 11.2333 9.375 10.8724V9.12745C9.375 8.76662 9.655 8.47412 10 8.47412Z"
        fill="white"
      />
      <path
        d="M6.28917 3.75C4.57417 3.7525 3.68 3.79 3.11 4.36C2.5 4.97 2.5 5.95167 2.5 7.91667V12.0833C2.5 14.0475 2.5 15.0292 3.11 15.64C3.68 16.2092 4.57417 16.2475 6.28917 16.25C6.25 15.73 6.25 15.13 6.25 14.4808V5.51917C6.25 4.86917 6.25 4.26917 6.28917 3.75Z"
        fill="white"
      />
    </svg>
  );
};
